import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AuthorizationProviderState, AuthorizationServicesState } from './types';

const defaultAuthorizationProviderState: AuthorizationProviderState = {
  bulkAuthorizations: null,
  checkAuthorizationData: null,
  selectedAuthorization: null,
  transactionDetails: null,
  onSelectAuthorization: () => {},
  loadingState: {
    isLoadingTransactionDetails: false,
    isLoadingCheckAuthorization: false,
  },
  errorState: {
    transactionDetailsError: undefined,
    checkAuthorizationError: undefined,
  },
  authorizationToExecute: null,
  authorizationToCheck: null,
  isAuthorizationTransactionDetailsDrawerOpen: false,
  isAuthFlowDrawerOpen: false,
  toggleAuthorizationTransactionDetailsDrawer: () => {},
  onToggleAuthFlowDrawer: () => {},
  onTransactionDetailsMutation: () => {},
  initiateMandateService: () => params => new Promise<any>(() => {}),
  initiateBulkMandatesService: () => params => new Promise<any>(() => {}),
  executeMandateService: () => params => new Promise<any>(() => {}),
  executeBulkMandatesService: () => params => new Promise<any>(() => {}),
  onCheckAuthorizationMutation: () => {},
  onBulkAuthorizationSelect: () => {},
  onMassiveAuthorizationSelection: () => {},
  requestSpecialRate: false,
  onSetRequestNewRate: (value: boolean) => {},
  authAction: null,
  onSetAuthAction: (actionName: Nullable<string>) => {},
  shouldShowRequestNewRateBtn: false,
};

const defaultAuthorizationServicesState: AuthorizationServicesState = {
  authorizationService: null,
  transactionService: null,
};

export { defaultAuthorizationProviderState, defaultAuthorizationServicesState };
